<template>
    <Button
        class="campaign-edit__header-action-btn campaign-edit__header-action-btn--add-language"
        data-testid="editor-header__add-language-button"
        @click="onClickAddLanguage"
    >
        Add Language
    </Button>
    <CampaignLanguagesModal
        v-if="languageModalVisible"
        :visible="languageModalVisible"
        @update="onLanguageUpdate"
        @close="languageModalVisible = false"
    />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import CampaignLanguagesModal from "@/components/Campaign/CampaignLanguagesModal.vue";
import bus from "@/bus";
import type { LanguageCode } from "@/utils/languages";
import { updateLanguages } from "@/services/Language";

import { useGA4Tracking } from "@/composables/useGA4Tracking";
import GA4 from "@/enums/ga4Events";

export default defineComponent({
    name: "AddLanguage",
    components: { CampaignLanguagesModal },

    setup() {
        const ga4 = useGA4Tracking();
        return { ga4 };
    },

    data() {
        return {
            languageModalVisible: false
        };
    },

    computed: {
        campaignId() {
            return this.$route.params.campaignId as string;
        }
    },

    methods: {
        async onLanguageUpdate(languages: LanguageCode[]) {
            try {
                this.$snackbar.info("Updating Languages...");

                await updateLanguages(this.campaignId, languages);

                this.$snackbar.success("Languages updated.");
            } catch (e) {
                this.$snackbar.error("We could not update languages", `\n${e as string}`, {
                    duration: 0,
                    closable: true
                });
            } finally {
                bus.$emit("percentLoadEvent", 100);
            }
        },

        onClickAddLanguage() {
            this.languageModalVisible = true;
            this.ga4.trackClickEvent({
                interactionObject: GA4.CLICK_INTERACTION_OBJECTS.BUTTON,
                interactionText: GA4.CLICK_INTERACTION_TEXTS.ADD_LANGUAGE
            });
        }
    }
});
</script>
